import type { ReactNode } from 'react';

import { cn } from '@core/utils/cn';

export interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  className?: string;
}

export function PageHeader({ title, description, actions, className }: PageHeaderProps) {
  return (
    <div className={cn('mb-6 flex flex-wrap items-start gap-4', className)}>
      <div className="min-w-0 flex-1">
        <h1 className="text-[28px] font-semibold tracking-[-0.021em]">{title}</h1>
        {description && <p className="text-fg-muted mt-1 text-[15px]">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
